module.exports = {
  CLAIMED: 'claimed',
  CAN_BE_CLAIMED: 'can_be_claimed',
  UPCOMING: 'upcoming',
};
